import { render, staticRenderFns } from "./CustomerPortalSettingsModal.vue?vue&type=template&id=e5aa5d12&"
import script from "./CustomerPortalSettingsModal.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports